export class TUtilsData {
  georange: number;
  nearbyDriversDistanceInKm: number;
  baseFare: number;
  debounceTime: number;
  preBookRideTime: number;
}
